<template>
  <div>
    <v-row class="pa-5 mx-2 mt-5">
      <v-col class="mt-5 col-lg-6">
        <h1>
          Saiba mais sobre nossos produtos
        </h1>
      </v-col>
    </v-row>
    <h2 class="mx-3 mb-2">Engenharia:</h2>
    <div
      class="d-inline-flex flex-wrap justify-center align-center ml-0 ml-lg-4"
    >
      <div
        v-for="(engineerProduct, i) in engineerProducts"
        :key="i"
        class="d-inline-flex flex-wrap justify-center align-center"
      >
        <ProductCard
          :title="engineerProduct.title"
          :img="engineerProduct.img"
          class="mb-4"
        />
      </div>
    </div>
    <v-spacer />
    <h2 class="mx-3 mt-5 mb-2">Montagens Eletromecânicas:</h2>
    <div
      class="d-inline-flex flex-wrap justify-center align-center ml-0 ml-lg-4"
    >
      <div
        v-for="(maintenanceProduct, i) in maintenanceProducts"
        :key="i"
        class="d-inline-flex justify-center mb-5 ml-1"
      >
        <ProductCard
          :title="maintenanceProduct.title"
          :img="maintenanceProduct.img"
          class="mb-5"
        />
      </div>
    </div>
    <v-spacer />
    <Footer :hasContact="true" />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import ProductCard from "@/components/ProductCard.vue";

export default {
  data() {
    return {
      engineerProducts: [
        {
          img: "cemar/cemar1.png",
          title:
            "Desenvolvimento de Projetos de Subestações Elétricas até 230 kV"
        },
        {
          img: "aereas.png",
          title: "Projetos de Linha de Transmissão com Ramais Aéreos até 230kV"
        },
        {
          img: "subestacao.png",
          title:
            "Estudos de Viabilidade Econômica para Indústrias em ampliações com necessidade da implantação de nova Subestação em 69 kV, ou 138 kV."
        },
        {
          img: "subterranea.jpg",
          title:
            "Projetos de Linhas de Transmissão com Ramais Subterrâneos ate 138 kV"
        }
      ],
      maintenanceProducts: [
        {
          img: "abb/abb2.png",
          title: "Construção e Montagem de Subestações até 230kV."
        },
        {
          img: "transmissao.png",
          title: "Construção de Linhas de Transmissão de 34.5 kV até 230 kV."
        },
        {
          img: "petrobras/petrobras2.png",
          title: "Instalação de Usinas Geradoras a Diesel ou Gás."
        }
      ]
    };
  },
  name: "Products",
  components: {
    Footer,
    ProductCard
  }
};
</script>
